<div class="flex-1 d-flex fd-col jc-start ai-stretch">
  <h4 class="header-top-margin">{{ option.filterMethodConfig?.title }}</h4>
  <div class="flex-1 d-flex fd-row flex-wrap jc-start">
    <ng-container *ngFor="let itemList of checkboxesModel">
      <div
        [style.flex]="columnFlex"
        class="list-container d-flex fd-col jc-start ai-stretch"
      >
        <p class="category-checkbox" *ngIf="itemList.name !== 'anonymous'; else noListCheckbox">
          <mat-checkbox
            (change)="categoryChecked($event, itemList)"
            [checked]="itemList.checked"
            [indeterminate]="itemList.indeterminate"
            color="primary"
            >{{ itemList.name }}
          </mat-checkbox>
        </p>
        <ng-template #noListCheckbox>
          <p class="category-checkbox"></p>
        </ng-template>
        <ng-container *ngIf="itemList.items?.length">
          <p class="item-checkbox" *ngFor="let item of itemList.items; let i = index">
            <mat-checkbox
              [checked]="item.checked"
              (change)="itemChecked($event, item, itemList)"
              color="primary"
              >{{ item.name }}
            </mat-checkbox>
          </p>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
